// src/pages/LoginPage.js
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { signIn } from '../lib/supabase'
import { useToast } from '../components/Toast'
import { useLang } from '../lib/i18n'
import Navbar from '../components/Navbar'
import SocialFooter from '../components/SocialFooter'
import './AuthPage.css'

export default function LoginPage() {
  const navigate = useNavigate()
  const toast    = useToast()
  const { t }    = useLang()
  const [form, setForm]       = useState({ email: '', password: '' })
  const [showPass, setShowPass] = useState(false)
  const [loading, setLoading] = useState(false)

  function handleChange(e) { setForm(f => ({ ...f, [e.target.name]: e.target.value })) }

  async function handleSubmit(e) {
    e.preventDefault()
    if (!form.email || !form.password) return
    setLoading(true)
    const { error } = await signIn({ email: form.email, password: form.password })
    setLoading(false)
    if (error) { toast.show(t('incorrectCredentials') || 'Incorrect email or password', 'error'); return }
    navigate('/dashboard')
  }

  return (
    <div className="auth-page">
      <Navbar />
      <div className="auth-wrap">
        <div className="auth-box">
          <div className="auth-box__header">
            <p className="auth-box__eyebrow">Members Only</p>
            <h1 className="auth-box__title">{t('welcomeBack')}</h1>
            <p className="auth-box__sub">{t('signInToAccess')}</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="field">
              <label>{t('emailAddress')}</label>
              <input name="email" type="email" placeholder="your@email.com"
                value={form.email} onChange={handleChange} required autoComplete="email" />
            </div>
            <div className="field">
              <label>{t('password')}</label>
              <div className="pass-wrap">
                <input name="password" type={showPass ? 'text' : 'password'}
                  placeholder="Your password" value={form.password} onChange={handleChange}
                  required autoComplete="current-password" />
                <button type="button" className="pass-toggle" onClick={() => setShowPass(v => !v)}>
                  {showPass ? '🙈' : '👁'}
                </button>
              </div>
            </div>
            <div style={{ textAlign:'right', marginBottom:16, marginTop:-8 }}>
              <Link to="/forgot-password" style={{ fontSize:12, color:'var(--muted)' }}>
                {t('forgotPassword')}
              </Link>
            </div>
            <button className="btn btn--gold btn--full" type="submit" disabled={loading}>
              {loading ? 'Signing in...' : t('enterVault')}
            </button>
          </form>

          <p className="auth-switch">
            {t('noCard')} <Link to="/join">{t('chooseYourTier')}</Link>
          </p>
        </div>
      </div>
      <SocialFooter />
    </div>
  )
}
